
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-rotator",
      function () {
        return require("private-next-pages/image-rotator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-rotator"])
      });
    }
  